import { AddChain } from './AddChain.main';

export { AddChain };
